import React, { useState } from 'react';
import leftarrow from '../../../../../../assets/arrow-left.svg';
import rightarrow from '../../../../../../assets/arrow-right.svg';

const Pagination = ({ currentPage, totalPages, totalItems, onPageChange }) => {
  const [goToPage, setGoToPage] = useState('');

  const handlePageChange = (page) => {
    if (page !== currentPage && page > 0 && page <= totalPages) {
      onPageChange(page);
    }
  };


  const handlePreviousClick = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];

    // Always show the first page number
    pageNumbers.push(
      <div
        key={1}
        className={`pagination-number ${currentPage === 1 ? 'active' : ''}`}
        onClick={() => handlePageChange(1)}
      >
        1
      </div>
    );

    if (totalPages > 1) {
      if (totalPages <= 6) {
        for (let i = 2; i <= totalPages; i++) {
          pageNumbers.push(
            <div
              key={i}
              className={`pagination-number ${currentPage === i ? 'active' : ''}`}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </div>
          );
        }
      } else {
        // Determine the segment to display based on currentPopupPage
        if (currentPage <= 3) {
          // Show pages 2, 3, 4 and ellipsis if more pages
          for (let i = 2; i <= 4; i++) {
            pageNumbers.push(
              <div
                key={i}
                className={`pagination-number ${currentPage === i ? 'active' : ''}`}
                onClick={() => handlePageChange(i)}
              >
                {i}
              </div>
            );
          }
          if (totalPages > 5) {
            pageNumbers.push(
              <div key="ellipsis" className="pagination-number ellipsis">
                .......
              </div>
            );
          }
          pageNumbers.push(
            <div
              key={totalPages}
              className={`pagination-number ${currentPage === totalPages ? 'active' : ''}`}
              onClick={() => handlePageChange(totalPages)}
            >
              {totalPages}
            </div>
          );
        } else if (currentPage >= totalPages - 2) {
          // Show the last 4 pages and ellipsis if more than 4 pages
          pageNumbers.push(
            <div
              key={1}
              className={`pagination-number ${currentPage === 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(1)}
            >
              2
            </div>
          );
          if (totalPages > 5) {
            pageNumbers.push(
              <div key="ellipsis" className="pagination-number ellipsis">
                ..
              </div>
            );
          }
          for (let i = totalPages - 3; i <= totalPages; i++) {
            pageNumbers.push(
              <div
                key={i}
                className={`pagination-number ${currentPage === i ? 'active' : ''}`}
                onClick={() => handlePageChange(i)}
              >
                {i}
              </div>
            );
          }
        } else {
          pageNumbers.push(
            <div
              key={1}
              className={`pagination-number ${currentPage === 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(1)}
            >
              2
            </div>
          );
          if (currentPage > 4) {
            pageNumbers.push(
              <div key="ellipsis-start" className="pagination-number ellipsis">
                ..
              </div>
            );
          }
          for (let i = Math.max(currentPage - 1, 2); i <= Math.min(currentPage + 1, totalPages - 1); i++) {
            pageNumbers.push(
              <div
                key={i}
                className={`pagination-number ${currentPage === i ? 'active' : ''}`}
                onClick={() => handlePageChange(i)}
              >
                {i}
              </div>
            );
          }
          if (currentPage < totalPages - 3) {
            pageNumbers.push(
              <div key="ellipsis-end" className="pagination-number ellipsis">
                ..
              </div>
            );
          }
          pageNumbers.push(
            <div
              key={totalPages}
              className={`pagination-number ${currentPage === totalPages ? 'active' : ''}`}
              onClick={() => handlePageChange(totalPages)}
            >
              {totalPages}
            </div>
          );
        }
      }
    }

    return pageNumbers;
  };

  const renderPaginationInfo = () => {
    const startItem = (currentPage - 1) * 10 + 1;
    const endItem = Math.min(currentPage * 10, totalItems);

    return ` ${startItem} to ${endItem} of ${totalItems} `;
  };

  if (totalPages === 1) {
    return null; // If there is only 1 page, return null to hide pagination
  }


  return (
    <div className="pagination-container">
      <div className="pagination-info">
        {renderPaginationInfo()}
      </div>
      <div className="pagination-controls">
        <div
          className={`pagination-control ${currentPage === 1 ? 'disabled' : ''}`}
          onClick={handlePreviousClick}
        >
          <img className='left-arrow' src={leftarrow} alt="leftarrow" />

        </div>
      </div>
      <div className="pagination-numbers">
        {renderPageNumbers()}
      </div>
      <div className="pagination-controls">
        <div
          className={`pagination-control ${currentPage === totalPages ? 'disabled' : ''}`}
          onClick={handleNextClick}
        >

          <img className='right-arrow' src={rightarrow} alt="rightarrow" />
        </div>
      </div>


      <style jsx>{`
        .pagination-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 6px 14px;
          border-radius: 6px;
          background: #F4F8FE;
          margin-top: 10px; /* Adjust margin as needed */
        }

        .pagination-info {
          font-size: 14px;
          color: #4B628A;
        }

        .pagination-number {
          color: #ABB4C4;
          text-align: center;
          font-family: Inter;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          cursor: pointer;
          padding: 12px;
        }

        .pagination-number.active {
          color: #4B628A;
          text-align: center;
          font-family: Inter;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          background-color: white;
          padding: 12px;
          border-radius: 8px;
        }

        .pagination-controls {
          display: flex;
          align-items: center;
        }

        .pagination-control {
          cursor: pointer;
          color: #4B628A;
          font-family: Inter;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          display: flex;
          align-items: center;
        }
        .pagination-control span {
          margin: 0 6px;
        }


        .pagination-control.disabled {
          cursor: pointer;
          color: #ABB4C4;
          font-family: Inter;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          color: #ccc;
          cursor: default;
        }

        .pagination-numbers {
          display: flex;
          gap: 10px;
        }

        .pagination-go-to {
          display: flex;
          align-items: center;
        }

        .pagination-go-to p {
          margin-right: 10px;
        }

        .pagination-go-to input {
          padding: 8px;
          border-radius: 5px;
          color: #4B628A;
          font-family: Inter;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          width: 30px;
          min-width: 30px;
          border: none;
        }
        .pagination-go-to input:focus {
          outline: 0;
        }
      `}</style>
    </div>
  );
};

export default Pagination;